// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"812e5fe1","291":"d2ead983","411":"5eb4f356","453":"e0eb14ff","455":"ef14f431","532":"ea0de6ac","679":"6248ef00","940":"514bad60","950":"7d273c60"}[chunkId] + ".chunk.js";
};